import t_19_2076_colorized from './KZ.T.18.2076.svg'
import t_19_2076 from './KZ.T.18.2076 black.svg'

export default [
  t_19_2076_colorized,
  t_19_2076,
]
